import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlToPlainText',
})
export class HtmlToPlainTextPipe implements PipeTransform {
  transform(description: string | null): string | null {
    if (!description) {
      return description;
    }

    const parser = new DOMParser();
    const dom = parser.parseFromString(description, 'text/html');
    const result = dom.body.textContent ?? '';
    return result.replace(/\r\n/g, '  ').replace(/\n/g, ' ');
  }
}
